



























import {
  Component, Vue, Prop,
} from 'vue-property-decorator';
import { FilterDTO } from '@/api';
import ThingTemperatureInput from '@/components/things/ThingTemperatureInput.vue';

interface IForm {
  categoryId?: number;
  name?: string;
  brand?: string;
  size?: string;
  temperatureFrom: number,
  temperatureTo: number,
}

@Component({
  name: 'thing-options',
  components: {
    ThingTemperatureInput,
  },
})
export default class Clients extends Vue {
  @Prop({ type: Number, required: true }) index!: number;

  @Prop({ type: Object, required: true }) form!: IForm;

  @Prop({ type: Array, default: () => [] }) categories!: FilterDTO[];

  // @Prop({ type: Array, default: () => [] }) brands!: string[];

  get brand() {
    return this.form.brand;
  }

  set brand(value: string | undefined) {
    this.updateForm<'brand'>('brand', value);
  }

  get categoryId() {
    return this.form.categoryId;
  }

  set categoryId(value: number | undefined) {
    this.updateForm<'categoryId'>('categoryId', value);
  }

  get name() {
    return this.form.name;
  }

  set name(value: string | undefined) {
    this.updateForm<'name'>('name', value);
  }

  get size() {
    return this.form.size;
  }

  set size(value: string | undefined) {
    this.updateForm<'size'>('size', value);
  }

  get temperature() {
    return [this.form.temperatureFrom, this.form.temperatureTo];
  }

  set temperature(value) {
    this.updateForm<'temperatureFrom'>('temperatureFrom', value[0]);
    this.updateForm<'temperatureTo'>('temperatureTo', value[1]);
  }

  updateForm<K extends keyof IForm>(propertyName: K, value: IForm[K]) {
    this.$emit('field-change', this.index, propertyName, value);
  }

  createFilter(queryString: string) {
    return (link: string) => (link.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
  }

  // queryBrand(queryString: string, cb: (items: string[]) => void) {
  //   const { brands } = this;
  //   const results = queryString ? brands.filter(this.createFilter(queryString)) : brands;
  //   cb(results);
  // }

  selectBrand(value: string) {
    this.brand = value;
  }
}
